import React, { Component } from 'react'
import { observer } from 'mobx-react'
import store from './store'
import Dialog from '../Dialog'
import style from '../style.module.less'
import { isNewOpen } from '@util'

@observer
export default class extends Component {
  componentDidMount() {
    store.startGetUnreadNoticeLoop()
  }

  componentWillUnmount() {
    store.getUnreadNoticeLoop.stop()
  }

  render() {
    const { toNotice, unreadNoticeCount } = store

    return (
      <div style={{ position: 'relative' }}>
        <a className={style.notice} onClick={toNotice}>
          {unreadNoticeCount > 0 && (
            <span className={style.unRead}>
              {+unreadNoticeCount > 99 ? '99+' : unreadNoticeCount}
            </span>
          )}
        </a>
        {!isNewOpen() && <Dialog />}
        <audio
          src="//qnm.hunliji.com/o_1cnos4hb711jh1ntd1h0816ho1ja09.wav"
          style={{ display: 'none' }}
          ref={audio => (store.noticeAudio = audio)}
        />
      </div>
    )
  }
}
